import React from 'react';
import {useDispatch, useSelector} from "react-redux";

const IFCLookupList_SortHeaders = ({_requestSort, _getClassNamesFor}) => {
    const dispatch = useDispatch();
    const selectedHospital = useSelector(state => state.auth.selectedHospital);
    const {keyword, status, page, filter, sortColumn, sortMode} = useSelector(state => state.bookingList);

    const requestSort = (_param, defaultAsc) => {
        return _requestSort(_param, defaultAsc)
    }
    const getClassNamesFor = _param => {
        return _getClassNamesFor(_param)
    }

    return (
        <thead>
        <tr>
            <th className="no-sort"><strong className="title">Description</strong></th>
            <th className="no-sort"><strong className="title">Item #</strong></th>
            <th className="no-sort"><strong className="title">Day/ON</strong></th>
            <th className="no-sort"><strong className="title">MPL/AHM</strong></th>
            <th className="no-sort"><strong className="title">AHSA</strong></th>
            <th className="no-sort"><strong className="title">BUPA</strong></th>
            <th className="no-sort"><strong className="title">PUBLIC</strong></th>
            <th className="no-sort"><strong className="title">Prosthesis Code</strong></th>
            <th className="no-sort text-right"><strong className="title">Details</strong></th>
        </tr>
        </thead>
    );

}

export default IFCLookupList_SortHeaders;